<template>
  <div>
    <b-row v-if="editMode">
      <b-col cols="12">
        <b-card
          no-body
          :class="'section section-' + section.id + ' section-edit-mode'"
        >
          <template #header>
            <h6 class="mb-0">
              {{ section.title ? section.title : "Sektion" }}
            </h6>
            <b-button-group class="ml-auto">
              <b-button
                @click="moveSection(-1)"
                variant="flat-secondary"
                size="sm"
                ><i class="fas fa-arrow-up"></i
              ></b-button>
              <b-button
                @click="moveSection(1)"
                variant="flat-secondary"
                size="sm"
                ><i class="fas fa-arrow-down"></i
              ></b-button>
              <b-button
                @click="alertRemoveSection"
                variant="flat-secondary"
                size="sm"
                ><i class="fas fa-trash "></i
              ></b-button>
            </b-button-group>
            <b-button
              v-b-toggle="'collapse-' + section.id"
              class="section-toggle"
              variant="link"
              size="sm"
              ><i class="fas fa-chevron-down"></i
            ></b-button>
          </template>
          <b-collapse visible :id="'collapse-' + section.id">
            <div class="card-body">
              <b-form-group label="Namn på sektionen">
                <validation-provider
                  #default="{ errors }"
                  name="Namn på sektionen"
                >
                  <b-form-input
                    :value="section.title"
                    @input="updateTitle"
                    :id="'sectionTitle' + section.id"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Namn på sektionen..."
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <component
                v-for="(content, index) in section.contents"
                :key="index"
                v-bind:is="content.type"
                :content="content"
                :editMode="true"
                v-on:alert-remove-content="alertRemoveContent"
                :id="content.id"
              />
              <hr class="my-2" />
              <b-form-group class="mb-0">
                <b-button
                  @click="openContentModal"
                  variant="secondary"
                  size="lg"
                  class="add-btn"
                  block
                  >Välj innehåll</b-button
                >
              </b-form-group>
            </div>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <b-card no-body :class="'section section-' + section.id">
          <template #header>
            <h6 class="mb-0">
              {{ section.title }}
            </h6>
            <b-button
              v-b-toggle="'collapse-' + section.id"
              variant="link"
              size="sm"
              ><i class="fas fa-chevron-down"></i
            ></b-button>
          </template>
          <b-collapse visible :id="'collapse-' + section.id">
            <div class="card-body">
              <!-- <h2>{{ section.title }}</h2> -->
              <div class="content-elements">
                <component
                  v-for="(content, index) in section.contents"
                  :key="index"
                  v-bind:is="content.type"
                  :content="content"
                />
              </div>
            </div>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";
import {
  BRow,
  BCol,
  BCard,
  BButtonGroup,
  BButton,
  BFormGroup,
  BFormInput,
  BCollapse,
} from "bootstrap-vue";
import { Components } from "@/models/ContentType";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("editArticle");

export default {
  data() {
    return {
      activeContent: {},
      required,
    };
  },
  props: {
    section: {},
    index: Number,
    editMode: Boolean,
  },
  components: {
    ...Components,
    BRow,
    BCol,
    BCard,
    BButtonGroup,
    BButton,
    BFormGroup,
    BFormInput,
    BCollapse,
    ValidationProvider,
  },
  methods: {
    ...mapActions(["deleteContent", "updateSection"]),
    updateTitle: function(title) {
      let section = this.section;
      section.title = title;
      this.updateSection(section);
    },
    openContentModal: function() {
      this.$emit("open-content-modal", this.section);
    },
    alertRemoveSection: function() {
      this.$emit("open-remove-section-alert", this.section);
    },
    alertRemoveContent: function(content) {
      this.activeContent = content;
      this.$swal({
        title: "Radera innehåll",
        text: "Vill du verkligen radera innehållet?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Radera",
        cancelButtonText: "Avbryt",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-secondary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (content.video && content.video.url1 !== "NIL") {
            this.$store.dispatch("deleteVideo", content.video);
          }

          this.removeContent();
        }
      });
    },
    removeContent: function() {
      let payload = { content: this.activeContent, section: this.section };
      this.deleteContent(payload);
    },
    moveSection: function(amount) {
      this.$emit("moveSection", amount, this.section.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
.add-btn {
  // padding: 1.5rem;
  border-style: dotted !important;
}
// .add-btn span {
//   display: block;
//   margin-bottom: 4px;
// }
</style>
